import { useState, useRef } from "react";
import { sticky_colors, shapes, popularEmoji } from "./Series_List_Data";

const { board } = window.miro;

function QuickKit({ stickyOnly }) {
  const [toolOpen, setToolOpen] = useState(false);
  /* ---------------------------------------------------------- */
  // Async functions iterating through colors & shape types
  // to build sets
  const [emojiCount, setEmojiCount] = useState(10);
  const [setHeight, setHeightState] = useState("0px");
  const content = useRef(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content.current.scrollHeight}px`);
  }

  async function makeAllColorsOfStickies() {
    // setStickyWidth(viewWidth /  sticky_colors.length);
    // const { centerX, centerY } = setMyViewport();
    const { x, y, width, height } = await board.viewport.get();
    const centerX = x + width * 0.5;
    const centerY = y + height * 0.5;

    let stickyWidth = 400;
    let marginX = 0.15 * stickyWidth;

    let xOffset;
    let newX;

    sticky_colors.forEach((color, index) => {
      xOffset = stickyWidth * index + marginX * index;
      newX = centerX + xOffset;

      buildSticky({
        style: { fillColor: color },
        x: newX,
        y: centerY,
        width: stickyWidth,
      });
    });
  }

  async function makeAllShapes() {
    // setShapeWidth(viewWidth / shapes.length);
    // const { centerX, centerY } = setMyViewport();
    const { x, y, width, height } = await board.viewport.get();
    const centerX = x + width * 0.5;
    const centerY = y + height * 0.5;

    let shapeWidth = 400;
    let aspect = 1;
    let shapeHeight = shapeWidth * aspect;
    let marginX = 0.15 * shapeWidth;

    let xOffset;
    let newX;

    return shapes.map((shape, index) => {
      xOffset = index * shapeWidth + index * marginX;
      newX = centerX + xOffset;

      buildShape({
        shape: shape,
        x: newX,
        y: centerY,
        width: shapeWidth,
        height: shapeHeight,
        style: { fillColor: "#FFFFF" },
      });
    });
  }
  /* ---------------------------------------------------------- */

  /* ---------------------------------------------------------- */
  // Async functions for creating individual items
  async function buildSticky(sticky) {
    const newSticky = await board.createStickyNote(sticky);
    return newSticky;
  }

  async function buildShape(shape) {
    const newShape = await board.createShape(shape);
    return newShape;
  }

  //   async function buildText(text) {
  //     const newText = await board.createText(text);
  //     return newText;
  //   }

  //   async function buildCard(card) {
  //     const newCard = await board.createCard(card);
  //     return newCard;
  //   }

  //   async function buildFrame(card) {
  //     const newFrame = await board.createFrame(card);
  //     return newFrame;
  //   }

  /* ---------------------------------------------------------- */

  // EMOJI KIT
  async function makeEmoji() {
    const { x, y, width, height } = await board.viewport.get();
    const centerX = x + width * 0.5;
    const centerY = y + height * 0.5;
    const emojiWidth = 246;
    let emojiHeight = emojiWidth & 0.58;
    let count = 0;
    const emojiToCreate = [];

    for (let i = 0; i < emojiCount; i++) {
      // would like to wrap eventually ... every 10
      let newEmojiObj = {
        content: popularEmoji[i],
        style: {
          fillColor: "transparent",
          fillOpacity: 1,
          fontFamily: "arial",
          fontSize: emojiWidth / 2.1,
          textAlign: "center",
        },
        x: centerX + emojiWidth * i,
        y: centerY,
        width: emojiWidth,
      };
      emojiToCreate.push(newEmojiObj);
    }
    // emojiToCreate.forEach((emojiOb) => board.createText(emojiOb));
    let result;
    let promises = [];
    for (let i = 0; i < emojiToCreate.length; i++) {
      promises.push(board.createText(emojiToCreate[i]));
    }
    result = await Promise.all(promises);
  }

  return (
    <div id="quick-kit-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="...-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 icon m2 icon-timer mb-0"></div>
        <h3 className="h3 cs2 ce11 mt-0 mb-0 ">Quick Kits</h3>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>{" "}
      </div>

      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          <button
            type="button"
            className="button fix-button-secondary button-secondary button-small cs1 ce7 mb-0"
            onClick={makeAllColorsOfStickies}>
            <>
              Every Color of Sticky
              {/* <div className="icon m2 icon-sticky-bulk mt--16 mb-0"></div> */}
            </>
          </button>
          <button
            style={{ display: stickyOnly === true ? "none" : "block" }}
            type="button"
            className="button fix-button-secondary button-secondary button-small mr-0  cs8 ce12 mb-0"
            onClick={makeAllShapes}>
            Every Shape
            {/* <div className="grid mb-0 mt--16">
              <div className="icon m2 icon-rectangle mb-0 cs1"></div>
              <div className="icon m2 icon-oval mb-0 cs2"></div>
              <div className="icon m2 icon-star-1 mb-0 cs3"></div>

              <div className="icon m2 icon-rhombus mb-0 cs10"></div>
              <div className="icon m2 icon-triangle mb-0 cs11"></div>
              <div className="icon m2 icon-oval mb-0 cs12"></div>
            </div> */}
          </button>
          <div className="cs1 ce12 grid mt-8">
            <input
              name="popular-emojis"
              type="number"
              className="cs1 ce3 input input-small ml-2"
              placeholder="1"
              min="1"
              max="82"
              value={emojiCount}
              onChange={(e) => setEmojiCount(e.target.value)}
            />
            <div className="p-large cs4 ce5">of the</div>
            <button
              type="button"
              className=" cs6 ce12 button fix-button-secondary button-secondary button-small "
              onClick={makeEmoji}>
              🤣 Most Popular Emoji 🥰
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuickKit;
